// The top of each tile, in its product's own look, as Main.dc.html (laptop) and PhoneLibrary.dc.html
// (phone) draw them. Colours come from the tokens file through library.css.
import { Pentagon, LockIcon } from '../shell/Marks.jsx'

// "The Property Accelerator" -> ["The Property", "Accelerator"], as the boards break the names
function twoLines(name) {
  const words = name.split(/\s+/)
  const cut = Math.ceil(words.length / 2)
  return [words.slice(0, cut).join(' '), words.slice(cut).join(' ')]
}

function Locked({ text, small }) {
  if (!text) return null
  return (
    <div className={`art-lock${small ? ' art-lock--small' : ''}`}>
      <LockIcon size={small ? 20 : 26} />
      <span>{text}</span>
    </div>
  )
}

export function TileArt({ tile }) {
  const [first, second] = twoLines(tile.name)
  switch (tile.art) {
    case 'fe':
      return (
        <div className="art art--fe">
          <div className="art-fe-bar" aria-hidden="true" />
          <div className="art-fe-name">{first.toUpperCase()}<br />{second.toUpperCase()}</div>
          <div className="art-fe-cohort">{tile.cohortLabel || ''}</div>
          <Locked text={tile.locked} />
        </div>
      )
    case 'acc':
      return (
        <div className="art art--acc">
          <div className="art-acc-cohort">{tile.cohortLabel || ''}</div>
          <div className="art-acc-name">{first}<br />{second}</div>
          <div className="art-acc-rule" aria-hidden="true" />
          <Locked text={tile.locked} />
        </div>
      )
    case 'masterclass':
      return (
        <div className="art art--masterclass">
          <div className="art-mc-name">{tile.name}</div>
          <Locked text={tile.locked} />
        </div>
      )
    case 'pcfl':
      return (
        <div className="art art--pcfl">
          {tile.cover && <img src={tile.cover} alt="" />}
          <div className="art-pcfl-chip">
            <Pentagon size={24} />
            <span>{tile.name}</span>
          </div>
          <Locked text={tile.locked} />
        </div>
      )
    case 'poyt':
      return (
        <div className="art art--poyt">
          <div className="art-poyt-eyebrow">Live cohort</div>
          <div className="art-poyt-name">{first}<br /><span className="poyt-underline poyt-underline--tile">{second}<span aria-hidden="true" /></span></div>
          <Locked text={tile.locked} />
        </div>
      )
    default:
      return (
        <div className="art art--master">
          <div className="art-master-bar" aria-hidden="true" />
          <div className="art-master-name">{tile.name}</div>
          <Locked text={tile.locked} />
        </div>
      )
  }
}

export function PhoneArt({ tile }) {
  const [first, second] = twoLines(tile.name)
  switch (tile.art) {
    case 'fe':
      return (
        <span className="part part--fe">
          <span className="part-fe-bar" aria-hidden="true" />
          <span className="part-fe-name">{tile.name.toUpperCase()}</span>
          <Locked text={tile.locked} small />
        </span>
      )
    case 'acc':
      return <span className="part part--acc"><span className="part-acc-name">{tile.name}</span><Locked text={tile.locked} small /></span>
    case 'masterclass':
      return <span className="part part--masterclass"><span className="part-mc-name">{tile.name}</span><Locked text={tile.locked} small /></span>
    case 'pcfl':
      return (
        <span className="part part--pcfl">
          {tile.cover && <img src={tile.cover} alt="" />}
          <span className="part-pcfl-chip"><Pentagon size={20} /></span>
          <Locked text={tile.locked} small />
        </span>
      )
    case 'poyt':
      return (
        <span className="part part--poyt">
          <span className="part-poyt-name">{first}<br /><span className="poyt-underline poyt-underline--phone">{second}<span aria-hidden="true" /></span></span>
          <Locked text={tile.locked} small />
        </span>
      )
    default:
      return <span className="part part--master"><span className="part-master-name">{tile.name}</span><Locked text={tile.locked} small /></span>
  }
}
